import React from 'react'
import styled from 'styled-components'
import { Box, Heading, Text, Link, Image } from 'rebass'
import AspectRatio from 'react-aspect-ratio'
import { Parallax } from 'react-scroll-parallax'
import { StaticQuery, graphql } from 'gatsby'
import Sticky from 'react-stickynode'

import Blob from '../images/blob-2.svg'
import NYTBlob from '../images/blob-3.svg'
import Cover from '../images/cover-cropped.gif'

import Img from 'gatsby-image'

import Tiltable from '../components/Tiltable'

const BlobWrap = styled(Box)`
  display: none;
  position: absolute;
  backface-visibility: hidden;
  top: -160px;
  right: 20%;
  background-image: url(${Blob});
  background-size: 165px;
  background-position: center center;
  background-repeat: no-repeat;
  padding: 8px;
  text-align: center;
  width: 180px;
  height: 135px;
  align-items: center;
  justify-content: center;
  letter-spacing: 1.45px;
  text-transform: uppercase;
  font-size: 14px;
  z-index: 50;

  @media (min-width: ${props => props.theme.breakpoints[0]}) {
    display: inline-flex;
  }

  a {
    transform: rotate(24deg);
    text-decoration: none;
  }
`

const NYTBlobWrap = styled(Box)`
  display: flex;
  margin: 0 auto 2rem;
  backface-visibility: hidden;
  background-image: url(${NYTBlob});
  background-size: 200px;
  background-position: center center;
  background-repeat: no-repeat;
  padding: 8px;
  text-align: center;
  width: 200px;
  height: 90px;
  align-items: center;
  justify-content: center;
  letter-spacing: 1.45px;
  text-transform: uppercase;
  font-size: 14px;
  z-index: 50;

  @media (min-width: ${props => props.theme.breakpoints[0]}) {
    position: absolute;
    top: 20%;
    left: 15%;
    margin: 0;
  }
`

const Divider = styled(Box)`
  background: ${props => props.theme.colors.black};
  width: 200px;
  height: 1px;
  margin: 0 auto;
`

const TruckImageWrap = styled(Box)`
  position: absolute;
  top: 0%;
  left: 5%;
  display: none;
  @media (min-width: ${props => props.theme.breakpoints[0]}) {
    display: inline-flex;
  }
`

const YearbookWrap = styled(Box)`
  position: absolute;
  top: 78%;
  z-index: 10;
  right: 5%;
  display: none;
  @media (min-width: ${props => props.theme.breakpoints[0]}) {
    display: inline-flex;
  }
`

const StudentCenterWrap = styled(Box)`
  position: absolute;
  right: 5%;
  top: 30%;
  display: none;
  @media (min-width: ${props => props.theme.breakpoints[0]}) {
    display: inline-flex;
  }
`

const TogetherTruckWrap = styled(Box)`
  position: absolute;
  left: 5%;
  top: 50%;
  display: none;
  @media (min-width: ${props => props.theme.breakpoints[0]}) {
    display: inline-flex;
  }
`

const BookCover = styled(Box)`
  box-shadow: 12px 13px 35px 0 rgba(0, 0, 0, 0.25);
`

const query = graphql`
  query {
    site {
      siteMetadata {
        purchaseLinks {
          title
          url
        }
      }
    }
    truck: file(relativePath: { eq: "tegan-truck.jpg" }) {
      childImageSharp {
        fixed(width: 210, height: 210) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    student: file(relativePath: { eq: "tegan-student-center.jpg" }) {
      childImageSharp {
        fixed(width: 214, height: 214) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    togetherTruck: file(relativePath: { eq: "together-truck.jpg" }) {
      childImageSharp {
        fixed(width: 280, height: 183) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    yearbook: file(relativePath: { eq: "yearbook.jpg" }) {
      childImageSharp {
        fixed(width: 213, height: 312) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`

const CoverSpread = () => (
  <StaticQuery
    query={query}
    render={data => {
      const amazonUrl = data.site.siteMetadata.purchaseLinks.find(
        l => l.title === 'Amazon'
      )
      return (
        <Box css={{ position: 'relative' }} py={[50, 100]}>
          <Sticky enabled={true} top={170} innerZ={50} activeClass="stuck">
            <BlobWrap>
              <Link
                href={amazonUrl.url}
                target="_blank"
                rel="noopener"
                color="yellow"
              >
                Order <br />
                now
              </Link>
            </BlobWrap>
          </Sticky>

          <NYTBlobWrap color="white">
            <Text
              css={{
                transform: `rotate(-6deg)`,
              }}
            >
              A NEW YORK TIMES BEST SELLER
            </Text>
          </NYTBlobWrap>

          <TruckImageWrap>
            <Parallax y={[-20, 30]}>
              <Tiltable>
                <Img
                  style={{
                    transform: 'rotate(-10deg)',
                    boxShadow: '0 0 15px 0 rgba(0,0,0,0.50)',
                  }}
                  fixed={data.truck.childImageSharp.fixed}
                />
              </Tiltable>
            </Parallax>
          </TruckImageWrap>
          <StudentCenterWrap>
            <Parallax y={[-20, 30]}>
              <Tiltable>
                <Img
                  style={{
                    transform: 'rotate(10deg)',
                    boxShadow: '0 0 15px 0 rgba(0,0,0,0.50)',
                  }}
                  fixed={data.student.childImageSharp.fixed}
                />
              </Tiltable>
            </Parallax>
          </StudentCenterWrap>
          <TogetherTruckWrap>
            <Parallax y={[-20, 30]}>
              <Tiltable>
                <Img
                  style={{
                    transform: 'rotate(-5deg)',
                    boxShadow: '0 0 15px 0 rgba(0,0,0,0.50)',
                  }}
                  fixed={data.togetherTruck.childImageSharp.fixed}
                />
              </Tiltable>
            </Parallax>
          </TogetherTruckWrap>
          <YearbookWrap>
            <Parallax y={[-20, 30]}>
              <Tiltable>
                <Img
                  style={{
                    transform: 'rotate(-5deg)',
                    boxShadow: '0 0 15px 0 rgba(0,0,0,0.50)',
                  }}
                  fixed={data.yearbook.childImageSharp.fixed}
                />
              </Tiltable>
            </Parallax>
          </YearbookWrap>
          <Box
            mx="auto"
            px={24}
            css={{
              maxWidth: '500px',
            }}
          >
            <AspectRatio ratio={89 / 136}>
              <BookCover>
                <Image
                  css={{ position: 'absolute', width: '100%', height: '100%' }}
                  src={Cover}
                  alt="High School book cover"
                />
              </BookCover>
            </AspectRatio>
          </Box>
          <Box py={48}>
            <Heading
              css={{ letterSpacing: 1.46, textTransform: 'uppercase' }}
              textAlign="center"
              fontSize={3}
            >
              Hardcover, MCD × FSG, 2019
              <br />
              $27.00
            </Heading>
          </Box>
          <Divider />
          <Box
            py={48}
            px={16}
            mx="auto"
            css={{
              maxWidth: '72ch',
              lineHeight: 1.5,
            }}
          >
            <Text
              fontSize={[3, '20px']}
              fontFamily="serif"
              textAlign="center"
              mt={3}
            >
              <em>High School</em> is the revelatory coming-of-age story of Sara
              and Tegan Quin, identical twins from Calgary, Alberta, who grew up
              during the peak of grunge and rave culture in the
              nineteen-nineties. Before they became the celebrated musicians and
              global LGBTQ icons we know today, Tegan and Sara skipped school,
              dropped acid, snuck out of the house, and fell in and out of love
              for the first time — sometimes with their best friends. Written in
              alternating chapters from Tegan's and Sara’s points of view,{' '}
              <em>High School</em> captures the discordant and parallel memories
              of two sisters struggling to understand their identities and
              beginning to see themselves, for the first time, as artists.
            </Text>
          </Box>
        </Box>
      )
    }}
  />
)

export default CoverSpread
